import { render } from "./ReportSales.vue?vue&type=template&id=7abb1ad8&scoped=true&ts=true"
import script from "./ReportSales.vue?vue&type=script&lang=ts"
export * from "./ReportSales.vue?vue&type=script&lang=ts"

import "./ReportSales.vue?vue&type=style&index=0&id=7abb1ad8&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abb1ad8"]])

export default __exports__